// A Google Sheets URL always starts with this host + path prefix.
export const GOOGLE_SHEET_URL_PREFIX = 'https://docs.google.com/spreadsheets/';

export const isValidGoogleSheetUrl = (url: string): boolean =>
  typeof url === 'string' && url.trim().startsWith(GOOGLE_SHEET_URL_PREFIX);

// The eight Grab markets and Taiwan offered when creating a journey campaign group.
// Add a market here when it becomes available in the Trident portal.
const TRIDENT_PORTAL_COUNTRY_CODES_BY_ID: Record<number, string> = {
  1: 'MY',
  2: 'PH',
  3: 'TH',
  4: 'SG',
  5: 'VN',
  6: 'ID',
  9: 'MM',
  10: 'KH',
  77: 'TW',
};

export const getTridentPortalCountries = (
  countries: Array<{ countryID: number; name: string; code?: string }>,
) =>
  countries
    .filter((country) => Boolean(TRIDENT_PORTAL_COUNTRY_CODES_BY_ID[country.countryID]))
    .map((country) => ({
      ...country,
      code: TRIDENT_PORTAL_COUNTRY_CODES_BY_ID[country.countryID],
    }));
